import React from 'react';
import LoginPage from './LoginPage';
import { puckImageField as imageField } from '../../../puck/fields/puckImageField';
import { puckMediaField as mediaField } from '../../../puck/fields/puckMediaField';
import { defaultMediaPuckProps, puckMediaFields } from '../../../media';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { resolveButtonBorder } from '../../../../shared/boxes/button/buttonStyles';
import { sitePrimaryColor } from '../../../puck/PuckSiteThemeContext';
import { puckButtonStyleSettingsField } from '../../../puck/fields/ButtonStyleField';
import { puckAdvancedSectionField, puckSectionField } from '../../../puck/fields/puckSectionField';

const loginPageConfig = {
  label: 'Page de connexion',
  defaultProps: {
    variant: 'minimal',
    backgroundImage: '',
    backgroundColor: '#f5f7fa',
    logoUrl: '',
    welcomeTitle: 'Bienvenue',
    welcomeSubtitle: 'Connectez-vous pour accéder au document.',
    // `submitBorder` et `submitButtonStyle` restent hors des defaultProps :
    // Puck les fusionnerait sous les props d'une page déjà en base et
    // changerait son bouton (cf. ButtonBlock.puck.jsx).
    submitColor: '',
    ...defaultMediaPuckProps,
  },
  fields: {
    _section1: puckSectionField('Média'),
    logoUrl: imageField('Logo'),
    backgroundImage: mediaField('Média de fond'),
    // Cadrage et ratio du média de fond : après la source, comme partout.
    ...puckMediaFields(),

    _section2: puckSectionField('Style'),
    variant: {
      type: 'select',
      label: 'Disposition',
      /* Options trop longues pour la demi-largeur. */
      layout: 'stacked',
      options: [
        { label: 'Minimal (formulaire centré)', value: 'minimal' },
        { label: 'Split (visuel gauche + form droite)', value: 'split' },
        { label: 'Plein écran (background image)', value: 'full' },
      ],
    },
    backgroundColor: puckColorField('Couleur de fond', { allowTransparent: true }),
    /* Bouton « Se connecter » : mêmes réglages que la box Bouton, moins la
       galerie de styles — la page n'a qu'un bouton, et il est toujours en
       pleine largeur du formulaire. */
    /* Sans réglage, le bouton prend la couleur principale et la bordure
       (pilule sans trait) par défaut des boutons : les champs affichent ce
       rendu-là, pas un blanc et un cadre de box que personne n'a choisis. */
    submitColor: puckColorField('Couleur du bouton', {
      emptyIsInherited: true,
      readInherited: (_props, { siteTheme }) => sitePrimaryColor(siteTheme) || '',
    }),
    submitBorder: puckBorderField('Bordures du bouton', {
      readDefaults: () => resolveButtonBorder(),
    }),
    // Titre d'accueil + sous-titre : plus des champs sidebar — édités inline sur
    // le canvas (texte riche, toolbar au survol). Valeurs de départ conservées
    // dans defaultProps, réécrites via PuckInlineRichText (contentProp).

    _section3: puckAdvancedSectionField(),
    submitButtonStyle: puckButtonStyleSettingsField('Apparence du bouton'),
  },
  render: (props) => (
    <div style={{ position: 'relative', height: 'calc(100vh - 56px)', overflow: 'hidden' }}>
      {/* props Puck contient déjà id + le vrai puck (dispatch) : indispensable
          pour que l'édition inline réécrive welcomeTitle/welcomeSubtitle. */}
      <LoginPage {...props} />
    </div>
  ),
};

export default loginPageConfig;
